export default "__VITE_ASSET__DloOxcxi__"